import { Injectable } from '@angular/core';
import { MediaHorasEtapasSimcaqDto } from '../../dtos/media-horas-etapas.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '..'
import { map, firstValueFrom } from 'rxjs';

interface ListMediaHorasEtapasSimcaqDto {
    content: MediaHorasEtapasSimcaqDto[];
  }
  
  @Injectable({
    providedIn: 'root',
  })
  export class MediaHorasEtapasSimcaqService {
    private apiUrl = `${environment.apiUrl}/turmas/media-horas-etapa-ensino`;
  
    constructor(
      private caqRequestService: CaqRequestService
    ) {}
  
    async buscarMediaHorasEtapasSimcaq(): Promise<MediaHorasEtapasSimcaqDto[]> 
    {
        const medias: MediaHorasEtapasSimcaqDto[] = await firstValueFrom(
            this.caqRequestService
                .get<ListMediaHorasEtapasSimcaqDto>(this.apiUrl)
                .pipe(map((response) => response.content))
        );

      return medias;
    }
  }
  